import { BoxProps, ColorOptions, convertHexToRGBA, ImageProps, TextProps } from '@jfs/ui-new'
import { Colors } from './../../util/util'

const shadow = {
  shadowOffset: { width: 0, height: 0 },
  shadowRadius: 2,
  shadowOpacity: 0.4,
  elevation: 3,
  shadowColor: 'BLUE',
} as BoxProps

const styles = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    bg: 'WHITE',
  } as BoxProps,
  labelStyle: {
    fontSize: 14,
    color: 'BLACK',
    lineHeight: 20,
    fontWeight: '700',
    textAlign: 'center',
    letterSpacing: -0.08,
    fontFamily: 'JioType-Bold',
  } as TextProps,
  descStyle: {
    fontSize: 12,
    color: convertHexToRGBA(Colors.BLACK, 65) as ColorOptions,
    lineHeight: 16,
    fontWeight: '500',
    textAlign: 'center',
    fontFamily: 'JioType-Medium',
  } as TextProps,
  buttonText: {
    fontSize: 12,
    color: 'PRIMARY',
    fontWeight: '600',
    fontFamily: 'JioType-Medium',
    letterSpacing: -0.06,
    textAlign: 'center',
  } as TextProps,
  button: {
    mt: 30,
    borderRadius: 24,
    borderColor: 'PRIMARY',
    borderWidth: 1,
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  imageContainer: {
    justify: 'center',
    paddingVertical: 10,
    paddingTop: 20,
    alignItems: 'center',
  } as BoxProps,
  image: {
    height: 140,
    width: 140,
  } as ImageProps,
}

export { styles }
